import React, { lazy } from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Linda R.',
    age: 71,
    quote: "I finally ate steak again after YEARS. My family couldn't believe it.",
    initials: 'LR',
    image: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?w=200&q=80'
  }, {
    name: 'Robert M.',
    age: 74,
    quote: 'No slipping at church. My confidence is completely back.',
    initials: 'RM',
    image: 'https://images.unsplash.com/photo-1559526324-593bc073d938?w=200&q=80'
  }, {
    name: 'Patricia K.',
    age: 68,
    quote: 'I threw away my old denture adhesive. Dentafix™ gel is so much better.',
    initials: 'PK',
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=200&q=80'
  }, {
    name: 'Dorothy S.',
    age: 76,
    quote: "My granddaughter said 'Grandma, you're smiling so much!' That made my year.",
    initials: 'DS',
    image: 'https://images.unsplash.com/photo-1581579438747-104c53d7fbc4?w=200&q=80'
  }, {
    name: 'James W.',
    age: 69,
    quote: 'I was skeptical, but after day one I was sold. Absolutely incredible.',
    initials: 'JW',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&q=80'
  }, {
    name: 'Barbara T.',
    age: 73,
    quote: "Comfortable, secure, and I forget I'm even wearing dentures.",
    initials: 'BT',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=80'
  }, {
    name: 'Harold P.',
    age: 77,
    quote: "Best purchase I've made in years. My only regret is not finding it sooner.",
    initials: 'HP',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80'
  }, {
    name: 'Nancy L.',
    age: 70,
    quote: 'I can finally eat out with friends without constant worry.',
    initials: 'NL',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80'
  }];
  return <section className="py-16 md:py-24 bg-gray-50" data-id="element-318">
      <div className="container mx-auto px-4 md:px-6" data-id="element-319">
        <div className="text-center mb-8" data-id="element-320">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 font-serif" data-id="element-321">
            Real People. Real Confidence. Real Results.
          </h2>
          <div className="flex justify-center items-center gap-2" data-id="element-322">
            <div className="flex" data-id="element-323">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-amber-500 text-amber-500" data-id="element-324" />)}
            </div>
            <span className="text-gray-600 font-medium" data-id="element-325">
              4.9/5 Average Rating
            </span>
          </div>
        </div>

        <div className="mb-12 grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-326">
          <img src="https://images.unsplash.com/photo-1529543544282-ea99407407c1?w=400&q=80" alt="Family enjoying dinner together" className="rounded-xl h-40 w-full object-cover shadow-md" loading="lazy" data-id="element-327" />
          <img src="https://images.unsplash.com/photo-1574279606130-09958dc756f7?w=400&q=80" alt="Senior laughing joyfully" className="rounded-xl h-40 w-full object-cover shadow-md" loading="lazy" data-id="element-328" />
          <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&q=80" alt="Confident couple outdoors" className="rounded-xl h-40 w-full object-cover shadow-md hidden md:block" loading="lazy" data-id="element-329" />
          <img src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=400&q=80" alt="Social gathering with friends" className="rounded-xl h-40 w-full object-cover shadow-md hidden md:block" loading="lazy" data-id="element-330" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-331">
          {testimonials.map((t, index) => <div key={index} className={`bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow ${index % 2 === 0 ? 'bg-white' : 'bg-rose-50/30'}`} data-id="element-332">
              <div className="flex items-center gap-1 mb-4" data-id="element-333">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-amber-500 text-amber-500" data-id="element-334" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-335">"{t.quote}"</p>
              <div className="flex items-center gap-3" data-id="element-336">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-gray-100" loading="lazy" data-id="element-337" />
                <div data-id="element-338">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-339">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-340">
                    Verified Buyer, {t.age}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}